import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"
import { isHTMLElement } from "~/types/types.util"

// Connects to data-controller="toast"
export default class extends Controller<HTMLElement> {
  private toast?: bootstrap.Toast

  connect() {
    this.toast = new bootstrap.Toast(this.element)
    this.show()
    document.addEventListener("mousedown", this.#handleClickOutside.bind(this))
  }

  show() {
    this.toast?.show()
  }

  hide() {
    this.toast?.hide()
  }

  disconnect() {
    document.removeEventListener("mousedown", this.#handleClickOutside)
  }

  #handleClickOutside(event: MouseEvent) {
    // Check if the toast element exists and the click is not inside the toast except on buttons
    if (this.element && isHTMLElement(event.target) && !this.element.contains(event.target)) {
      this.hide() // Manually hide the toast
    }
  }
}
